module.exports = __webpack_public_path__ + "737fc8077e28f74f495088e61fa95a33.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1084
// module chunks = 0